<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listDiyUpdateBtn">修改信息</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listSyncBtn">同步数据</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button>
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielId'"
                v-model="data.head['materielId']"
                code="materielId"
                name="物料ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielCode'"
                v-model="data.head['materielCode']"
                code="materielCode"
                name="物料编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_materielName'"
                v-model="data.head['materielName']"
                url="base/dictionary/medicinedic/materiel/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' },
                ]"
                search-key="name"
                code="materielName"
                name="物料名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_storeId'"
                v-model="data.head['storeId']"
                code="storeId"
                name="门店ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_storeCode'"
                v-model="data.head['storeCode']"
                url="base/user/user/store/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="storeCode"
                name="门店编码"
                default-value=""
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_storeName'"
                v-model="data.head['storeName']"
                code="storeName"
                name="门店名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielDescribe'"
                v-model="data.head['materielDescribe']"
                code="materielDescribe"
                name="物料描述"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_pinyinCode'"
                v-model="data.head['pinyinCode']"
                code="pinyinCode"
                name="拼音码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_materielTypeSign'"
                v-model="data.head['materielTypeSign']"
                code="materielTypeSign"
                name="类型标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.typeSign)"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielIotCode'"
                v-model="data.head['materielIotCode']"
                code="materielIotCode"
                name="条码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielInsuranceCode'"
                v-model="data.head['materielInsuranceCode']"
                code="materielInsuranceCode"
                name="医保码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_dicWeight'"
                v-model="data.head['dicWeight']"
                code="dicWeight"
                name="词典权重"
                :default-value="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_batchType'"
                v-model="data.head['batchType']"
                code="batchType"
                name="批次管理模式"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.batchType)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_unitPriceType'"
                v-model="data.head['unitPriceType']"
                code="unitPriceType"
                name="定价模式"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.unitPriceType)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_unitPrice'"
                v-model="data.head['unitPrice']"
                code="unitPrice"
                name="销售定价"
                :default-value="0"
                :disabled="data.head['unitPriceType']!=='1'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_unitPriceScale'"
                v-model="data.head['unitPriceScale']"
                code="unitPriceScale"
                name="加成比例"
                :default-value="0"
                :disabled="data.head['unitPriceType']!=='2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielMedUomId'"
                v-model="data.head['materielMedUomId']"
                code="materielMedUomId"
                name="药品单位ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMedUomCode'"
                v-model="data.head['materielMedUomCode']"
                code="materielMedUomCode"
                name="药品单位编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMedUomName'"
                v-model="data.head['materielMedUomName']"
                code="materielMedUomName"
                name="药品单位名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielMedSpecId'"
                v-model="data.head['materielMedSpecId']"
                code="materielMedSpecId"
                name="药品规格ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMedSpecCode'"
                v-model="data.head['materielMedSpecCode']"
                code="materielMedSpecCode"
                name="药品规格编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMedSpecName'"
                v-model="data.head['materielMedSpecName']"
                code="materielMedSpecName"
                name="药品规格名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielMedDosageId'"
                v-model="data.head['materielMedDosageId']"
                code="materielMedDosageId"
                name="药品剂型ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMedDosageCode'"
                v-model="data.head['materielMedDosageCode']"
                code="materielMedDosageCode"
                name="药品剂型编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMedDosageName'"
                v-model="data.head['materielMedDosageName']"
                code="materielMedDosageName"
                name="药品剂型名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielMeaUomId'"
                v-model="data.head['materielMeaUomId']"
                code="materielMeaUomId"
                name="计量单位ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMeaUomCode'"
                v-model="data.head['materielMeaUomCode']"
                code="materielMeaUomCode"
                name="计量单位编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielMeaUomName'"
                v-model="data.head['materielMeaUomName']"
                code="materielMeaUomName"
                name="计量单位名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-id
                :ref="'input_materielClassifyUomId'"
                v-model="data.head['materielClassifyUomId']"
                code="materielClassifyUomId"
                name="物料分类ID"
                :default-value="0"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_materielClassifyUomCode'"
                v-model="data.head['materielClassifyUomCode']"
                code="materielClassifyUomCode"
                name="物料分类编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_materielClassifyUomName'"
                v-model="data.head['materielClassifyUomName']"
                code="materielClassifyUomName"
                name="物料分类名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_effectiveSign'"
                v-model="data.head['effectiveSign']"
                code="effectiveSign"
                name="有效标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.effectiveSign)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_materielMedDosageCode'"
                      v-model="searcher['materielMedDosageCode']"
                      code="materielMedDosageCode"
                      name="药品剂型编码"
                      url="base/dictionary/medicinedic/meddictionary/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="name"
                      :searcher="{'medDirectoryCode':'XJ'}"
                      default-value=""
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_materielMedDosageName'"
                      v-model="searcher['materielMedDosageName']"
                      code="materielMedDosageName"
                      name="药品剂型名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_classifyUomCode'"
                      v-model="searcher['materielClassifyUomCode']"
                      code="classifyUomCode"
                      name="物料分类编码"
                      url="base/dictionary/medicinedic/classifydictionary/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="name"
                      :searcher="{}"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_classifyUomName'"
                      v-model="searcher['materielClassifyUomName']"
                      code="classifyUomName"
                      name="物料分类名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_materielTypeSign'"
                      v-model="searcher['materielTypeSign']"
                      code="materielTypeSign"
                      name="类型标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.typeSign)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_pinyinCode'"
                      v-model="searcher['pinyinCode']"
                      code="pinyinCode"
                      name="拼音码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_materielIotCode'"
                      v-model="searcher['materielIotCode']"
                      code="materielIotCode"
                      name="条码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_materielInsuranceCode'"
                      v-model="searcher['materielInsuranceCode']"
                      code="materielInsuranceCode"
                      name="医保码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_unitPriceType'"
                      v-model="searcher['unitPriceType']"
                      code="unitPriceType"
                      name="定价模式"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.unitPriceType)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_batchType'"
                      v-model="searcher['batchType']"
                      code="batchType"
                      name="批次管理模式"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.batchType)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_effectiveSign'"
                      v-model="searcher['effectiveSign']"
                      code="effectiveSign"
                      name="有效标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.effectiveSign)"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
                <el-row>
                  <!-- 文本 -->
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_materielTypeCode'"
                      v-model="searcher['materielTypeCode']"
                      code="materielTypeCode"
                      name="物料类型编码"
                      url="base/dictionary/medicinedic/materieltype/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="code"
                      :searcher="{}"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'input_materielCode'"
                      v-model="searcher['materielCode']"
                      code="materielCode"
                      name="物料编码"
                      url="base/dictionary/medicinedic/materiel/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="code"
                      :searcher="{}"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_materielName'"
                      v-model="searcher['materielName']"
                      code="materielName"
                      name="物料名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-id
            code="materielId"
            name="物料ID"
            :edit="false"
          />
          <ik-column-text
            code="materielCode"
            name="物料编码"
            :edit="false"
          />
          <ik-column-text
            code="materielName"
            name="物料名称"
            :edit="false"
          />
          <ik-column-id
            code="storeId"
            name="门店ID"
            :edit="false"
          />
          <ik-column-text
            code="materielDescribe"
            name="物料描述"
            :edit="false"
          />
          <ik-column-number
            code="dicWeight"
            name="词典权重"
            :edit="false"
          />
          <ik-column-select
            code="batchType"
            name="批次管理模式"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.batchType)"
            :edit="false"
          />
          <ik-column-select
            code="unitPriceType"
            name="定价模式"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.unitPriceType)"
            :edit="false"
          />
          <ik-column-number
            code="unitPrice"
            name="销售定价"
            :edit="false"
          />
          <ik-column-number
            code="unitPriceScale"
            name="加成比例"
            :edit="false"
          />
          <ik-column-text
            code="pinyinCode"
            name="拼音码"
            :edit="false"
          />
          <ik-column-select
            code="effectiveSign"
            name="有效标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.effectiveSign)"
            :edit="false"
          />
          <ik-column-select
            code="materielTypeSign"
            name="类型标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.typeSign)"
            :edit="false"
          />
          <ik-column-text
            code="materielIotCode"
            name="条码"
            :edit="false"
          />
          <ik-column-text
            code="materielInsuranceCode"
            name="医保码"
            :edit="false"
          />
          <ik-column-id
            code="materielMedUomId"
            name="药品单位ID"
            :edit="false"
          />
          <ik-column-text
            code="materielMedUomCode"
            name="药品单位编码"
            :edit="false"
          />
          <ik-column-text
            code="materielMedUomName"
            name="药品单位名称"
            :edit="false"
          />
          <ik-column-id
            code="materielMedSpecId"
            name="药品规格ID"
            :edit="false"
          />
          <ik-column-text
            code="materielMedSpecCode"
            name="药品规格编码"
            :edit="false"
          />
          <ik-column-text
            code="materielMedSpecName"
            name="药品规格名称"
            :edit="false"
          />
          <ik-column-id
            code="materielMedDosageId"
            name="药品剂型ID"
            :edit="false"
          />
          <ik-column-text
            code="materielMedDosageCode"
            name="药品剂型编码"
            :edit="false"
          />
          <ik-column-text
            code="materielMedDosageName"
            name="药品剂型名称"
            :edit="false"
          />
          <ik-column-id
            code="materielMeaUomId"
            name="计量单位ID"
            :edit="false"
          />
          <ik-column-text
            code="materielMeaUomCode"
            name="计量单位编码"
            :edit="false"
          />
          <ik-column-text
            code="materielMeaUomName"
            name="计量单位名称"
            :edit="false"
          />
          <ik-column-id
            code="materielClassifyUomId"
            name="物料分类ID"
            :edit="false"
          />
          <ik-column-text
            code="materielClassifyUomCode"
            name="物料分类编码"
            :edit="false"
          />
          <ik-column-text
            code="materielClassifyUomName"
            name="物料分类名称"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
    <!-- 物料修改用开窗 -->
    <el-dialog
      title="物料信息"
      :visible.sync="dialogVisible"
      width="50%"
      top="16vh"
      :show-close="false"
    >
      <div style="width:100%">
        <el-form
          id="enroll-dialog-form"
          v-model="data.head"
          class="enroll-dialog-form"
          :inline="true"
          label-width="80px"
          :disabled="false"
        >
          <el-row>
            <!-- 文本 -->
            <el-col :span="12">
              <ik-form-text
                :ref="'dig_input_materielCode'"
                v-model="data.head['materielCode']"
                code="materielCode"
                name="物料编码"
                default-value=""
                :min-length="0"
                :max-length="50"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-text
                :ref="'dig_input_materielName'"
                v-model="data.head['materielName']"
                :code="'materielName'"
                :name="'物料名称'"
                default-value=""
                :min-length="0"
                :max-length="50"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-select
                :ref="'input_unitPriceType'"
                v-model="data.head['unitPriceType']"
                code="unitPriceType"
                name="定价模式"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.unitPriceType)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <ik-form-number
                :ref="'dig_input_unitPrice'"
                v-model="data.head['unitPrice']"
                code="unitPrice"
                name="销售定价"
                :default-value="0"
                :disabled="data.head['unitPriceType'] !== '1'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-number
                :ref="'dig_input_unitPriceScale'"
                v-model="data.head['unitPriceScale']"
                code="unitPriceScale"
                name="加成比例"
                :default-value="0"
                :disabled="data.head['unitPriceType'] !== '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-select
                :ref="'input_effectiveSign'"
                v-model="data.head['effectiveSign']"
                code="effectiveSign"
                name="有效标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.effectiveSign)"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="updateInfo">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
// 表单组件
import IkFormId from '@/components/ik/form/input/IkFormId'
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormNumber from '@/components/ik/form/input/IkFormNumber'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnId from '@/components/ik/table/ikColumn/IkColumnId'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnNumber from '@/components/ik/table/ikColumn/IkColumnNumber'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkPagination from '@/components/ik/pagination/IkPagination'
import store from '@/store'

import { getById, findPage, save, update, remove, postData } from '@/api/ik/data/dataApi'
export default {
  components: {
    // 表单组件
    IkFormId,
    IkFormText,
    IkFormNumber,
    IkFormSelect,
    IkFormDataPopup,
    IkColumnId,
    IkColumnText,
    IkColumnNumber,
    IkColumnSelect,
    IkPagination
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'clinic/clinicdic/clinicmedicinedic/clinicmateriel',
      // Web路径
      webPath: 'clinic/clinic_dic/clinic_medicine_dic/clinic_materiel',
      // 标识字段JSON
      jsonStr: {
        effectiveSign: '[{"key": "0", "value": "无效"}, {"key": "1", "value": "有效"}]',
        typeSign: '[{"key": "1", "value": "中成药"}, {"key": "2", "value": "西药"}, {"key": "3", "value": "饮片"}, {"key": "4", "value": "服务"}, {"key": "5", "value": "产品"}]',
        unitPriceType: '[{"key": "1", "value": "固定售价"}, {"key": "2", "value": "进价加成"}]',
        batchType: '[{"key": "1", "value": "非批次管理"}, {"key": "2", "value": "批次管理"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {}
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      // 修改界面显示
      dialogVisible: false,
      verify: {
        head: {},
        body: {}
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/manager/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/manager/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/manager/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/manager/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/manager/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "materielMedDosageCode") {
        this.searcher["materielMedDosageCode"] = row.code
      } else if (code === "materielClassifyUomCode") {
        this.searcher["materielClassifyUomCode"] = row.code
      } else if (code === "storeCode") {
        this.searcher["storeCode"] = row.code
      } else if (code === "materielTypeCode") {
        this.searcher["materielTypeCode"] = row.code
      } else if (code === "materielCode") {
        this.searcher["materielCode"] = row.code
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "materielName") {
        this.data.head["materielId"] = row.id
        this.data.head["materielCode"] = row.code
        this.data.head["materielName"] = row.name
        this.data.head["materielTypeSign"] = row.typeSign
        this.data.head["materielIotCode"] = row.iotCode
        this.data.head["materielInsuranceCode"] = row.insuranceCode
        this.data.head["pinyinCode"] = row.pinyinCode
        this.data.head["materielMedUomId"] = row.medUomId
        this.data.head["materielMedUomCode"] = row.medUomCode
        this.data.head["materielMedUomName"] = row.medUomName
        this.data.head["materielMedSpecId"] = row.medSpecId
        this.data.head["materielMedSpecCode"] = row.medSpecCode
        this.data.head["materielMedSpecName"] = row.medSpecName
        this.data.head["materielMedDosageId"] = row.medDosageId
        this.data.head["materielMedDosageCode"] = row.medDosageCode
        this.data.head["materielMedDosageName"] = row.medDosageName
        this.data.head["materielMeaUomId"] = row.meaUomId
        this.data.head["materielMeaUomCode"] = row.meaUomCode
        this.data.head["materielMeaUomName"] = row.meaUomName
        this.data.head["materielClassifyUomId"] = row.classifyUomId
        this.data.head["materielClassifyUomCode"] = row.classifyUomCode
        this.data.head["materielClassifyUomName"] = row.classifyUomName
      } else if (code === "storeCode") {
        this.data.head["storeId"] = row.id
        this.data.head["storeCode"] = row.code
        this.data.head["storeName"] = row.name
      }
      console.log(this.data.head)
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      // 获取树组件数据
      $this.searcher.storeCode = $this.storeCode
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // 修改物料
    listDiyUpdateBtn() {
      // 显示修改界面
      this.dialogVisible = true
      // 查询数据
      this.get(this.activeRow.id)
    },
    updateInfo() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      $this.listLoading = true
      update($this.bgPath, $this.data).then(response => {
        $this.listLoading = false
        // 刷新数据
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已保存!'
        })
      }).catch(() => {
        $this.listLoading = false
        $this.dialogVisible = false
      })
    },
    // 同步数据词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      postData(this.bgPath + "/do/syncdic", { "storeCode": $this.storeCode }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        })
      }).catch(() => {
        $this.listLoading = false
      })
    }
  }
}
</script>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
</style>
